import type { ReactNode } from "react";
import RequireFlag from "../../../components/Permissions/RequireFlag";
import RequirePermission from "../../../components/Permissions/RequirePermission";

/** Guards the BPA import page: the 1.0 flag, plus edit permission. */
export default function CmsBpaImportRoute({ children }: { children: ReactNode }) {
  return (
    <RequireFlag flag="research-cms-1-enabled" redirectTo="/">
      <RequirePermission permission="staff.research.edit" redirectTo="/">
        {children}
      </RequirePermission>
    </RequireFlag>
  );
}
